import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { CheckCircle2, ArrowLeft } from 'lucide-react';
import { APPS } from '../lib/apps';

/** Branded Coming Soon workspace for apps planned in later ERP phases. */
export default function ComingSoonPage({ appKey }) {
  const app = APPS.find((a) => a.key === appKey);
  if (!app) return null;
  return (
    <div className="max-w-3xl" data-testid="coming-soon-panel">
      <div className="border bg-card rounded-xl p-6 sm:p-8 shadow-[var(--shadow-elev-1)]">
        <div className="flex items-start gap-4">
          <div className="h-12 w-12 rounded-xl bg-[hsl(var(--violet-soft))] flex items-center justify-center shrink-0">
            <app.icon size={22} className="text-[hsl(var(--brand-violet))]" />
          </div>
          <div className="min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <h1 className="font-heading font-semibold text-xl">{app.name}</h1>
              <Badge variant="outline" className="text-[10px] text-muted-foreground">Coming Soon</Badge>
            </div>
            <p className="text-sm text-muted-foreground mt-1">{app.description}. This workspace is part of a later ERP phase — the structure is ready and your data will plug straight in.</p>
          </div>
        </div>

        {(app.planned || []).length > 0 && (
          <div className="mt-6">
            <h2 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-2.5">Planned modules</h2>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2" data-testid="coming-soon-planned-list">
              {app.planned.map((p) => (
                <li key={p} className="flex items-center gap-2 text-sm text-muted-foreground">
                  <CheckCircle2 size={14} className="text-[hsl(var(--brand-violet))]/60 shrink-0" /> {p}
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="mt-7">
          <Button asChild variant="outline" size="sm" data-testid="coming-soon-back-button">
            <Link to="/"><ArrowLeft size={14} className="mr-1.5" /> Back to all apps</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
